import { UseModalVisibilityReturnType } from 'hooks';
import { CSSProperties } from 'react';

export const bodyStyle: CSSProperties = { overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' };

export interface EditSubscriptionProps {
  modal: UseModalVisibilityReturnType;
}
